import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getUserFromLocalStorage } from '../../../../../../utils/utils'
import axios from 'axios'
import { decryptResponse, encryptRequestBody } from '../../../../../../utils/customAxios'

const MobilePrtCommInside = () => {
	const [monthPRTCommission, setMonthPRTCommission] = useState([])
	const [page, setPage] = useState(1)
	const [pageSize, setPageSize] = useState(10)
	const [totalPages, setTotalPages] = useState(1)

	const params = useParams()
	const month = params?.month

	useEffect(() => {
		getMonthPRTCommission()
	}, [page, pageSize])

	const getMonthPRTCommission = async () => {
		try {
			const user = getUserFromLocalStorage()
			const headers = {}
			const access_token = user?.access_token
			if (user && access_token) {
				headers.authorization = `Bearer ${access_token}`
			}
			let body = { page, pagesize: pageSize, month }

			if (process.env.REACT_APP_ENV === 'production') {
				const encryptedRequest = encryptRequestBody(
					body,
					process.env.REACT_APP_REQUEST_CRYPTO_HEX_KEY,
					process.env.REACT_APP_REQUEST_CRYPTO_IV_KEY
				)
				body = encryptedRequest
			}

			const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/getPerticularMonthPRTCommission`, body, {
				headers: {
					...headers,
					'Content-Type': 'application/json',
				},
			})

			if (process.env.REACT_APP_ENV === 'production' && response.status === 200) {
				if (response.data) {
					const decryptedResponse = decryptResponse(
						response.data,
						process.env.REACT_APP_RESPONSE_CRYPTO_HEX_KEY,
						process.env.REACT_APP_RESPONSE_CRYPTO_IV_KEY
					)
					response.data = decryptedResponse
				}
			}

			if (response.data.status === 1) {
				setMonthPRTCommission(response.data.data)
				setTotalPages(response.data.total / pageSize)
			}
		} catch (error) {
			console.error('error', { error })
		}
	}

	const formatDate = (dateString) => {
		return new Date(dateString)
			.toLocaleDateString('en-IN', {
				day: '2-digit',
				month: 'short',
				year: 'numeric',
			})
			.toUpperCase()
			.replace('.', '')
	}
	return (
		<div>
			<div className='mb-5 mt-5'>
				<div class='card container-fluid w-95 mb-2 shadow-card '>
					<div className='row d-flex justify-content-between align-items-center '>
						<div className=' col-9 text-center'>
							<h3 className=' letter-normal text-normal text-black'>PRT Comm Details</h3>
						</div>
						<div className=' col-3 title-card-bg'>
							<img
								className='title-card-image ms-n4'
								src='https://cdn3d.iconscout.com/3d/premium/thumb/business-team-3d-icon-download-in-png-blend-fbx-gltf-file-formats--employee-teamwork-businessman-pack-icons-5791966.png?f=webp'
								alt=''
							/>
						</div>
					</div>
				</div>
				<div className='card container-fluid w-95 card-body shadow-card pt-2 mb-2'>
					<div className='d-flex justify-content-evenly align-items-center gap-2 pt-0'>
						<div>
							<div class='input-group input-group-outline  ' aria-label='Default select example'>
								<select class='dataTable-selector border-radius-lg dropdown-toggle ' id='exampleFormControlSelect1 '>
									<option value={10}> 10</option>
									<option value={25}> 25</option>
									<option value={50}> 50</option>
									<option value={75}> 75</option>
									<option value={100}> 100</option>
								</select>
							</div>
						</div>
					</div>
				</div>
				{monthPRTCommission.map((commission, index) => (
					<div className='shadow-card mx-auto container-fluid w-95 mt-2 mb-3'>
						<div className=' border-radius-2xl p-1 mt-2 circle-cut bg-dark'>
							<b className='fw-normal fs-6 text-white ms-3'>
								Date - <b className='text-md fw-bold'>{formatDate(commission?.createdAt)}</b>
							</b>
						</div>
						<div className='d-flex gap-2 container-fluid justify-content-between align-items-center mt-2 mb-2'>
							<div className='col-1'>
								<span class='bg-dark-yellow sno p-1 me-0'>
									<b className='text-black-50 text-sm'>{(page - 1) * pageSize + index + 1}</b>
								</span>
							</div>
							<div className='col-5 text-nowrap'>
								<span class='badge badge-lg badge-dot me-4 d-inline-block text-start'>
									<i class='bg-success'></i>
									<small className='fs-6 text-black-50 opacity-7'>Members</small>
								</span>
								<p className='fs-6 text-black fw-normal'>{commission?.count}</p>
							</div>
							<div className='col-5 text-nowrap'>
								<span class='badge badge-lg badge-dot me-4 d-inline-block text-start'>
									<i class='bg-info'></i>
									<small className='fs-6 text-black-50 opacity-7'>PRT Commission</small>
								</span>
								<p className='fs-6 text-black fw-bold'> ₹{commission?.prtCommission}</p>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default MobilePrtCommInside
